import { render, staticRenderFns } from "./card-account.vue?vue&type=template&id=6a2daff1&"
import script from "./card-account.vue?vue&type=script&lang=js&"
export * from "./card-account.vue?vue&type=script&lang=js&"
import style0 from "./card-account.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports